import { Component, OnInit } from '@angular/core';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
user: any = {};
  constructor( private dataService: DataService,) { }

  ngOnInit(): void {
      this.user = this.dataService.userDetail;
  }

}
